var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"17vh","flex":"1"},attrs:{"className":"chart","id":"riverWaterQuality"}})])
}]

export { render, staticRenderFns }